//states/login.js
import { make } from "vuex-pathify"

const state = {
  tableShowAddButton: true,
  tableAddButtonName: 'add',
  tableRows: [],
  tableSelectedRows: [],
  tableShowEditButtons: true,
  arrayEditTable: false,
  tableName: '',
  tableLoading: false,
  tableRowClickFunction: null,
  orgSensors: [],
  dictionary: [],
};

const mutations = make.mutations(state);


export default {
  namespaced: true,
  state,
  mutations
}